import { motion } from "framer-motion";
import { MessageCircle, Instagram, Facebook, Globe } from "lucide-react";

const channels = [
  { icon: MessageCircle, name: "WhatsApp", value: 721, color: "#22C55E" },
  { icon: Globe, name: "Chat Widget", value: 233, color: "#2563EB" },
  { icon: Instagram, name: "Instagram", value: 275, color: "#E4405F" },
  { icon: Facebook, name: "Facebook", value: 212, color: "#1877F2" },
];

export function ChannelPerformance() {
  const total = channels.reduce((acc, c) => acc + c.value, 0);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.55 }}
      className="rounded-[14px] bg-white p-6 shadow-sm border border-[#E2E8F0]"
    >
      <h3 className="text-lg font-semibold text-[#0F172A] mb-4">
        Performance por Canal
      </h3>

      <div className="space-y-4">
        {channels.map((channel, index) => (
          <motion.div
            key={channel.name}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.55 + index * 0.05 }}
            className="flex items-center gap-3"
          >
            <div
              className="flex h-9 w-9 items-center justify-center rounded-lg"
              style={{ backgroundColor: `${channel.color}15` }}
            >
              <channel.icon
                className="h-4 w-4"
                style={{ color: channel.color }}
              />
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm text-[#64748B]">{channel.name}</span>
                <span className="text-sm font-semibold text-[#0F172A]">
                  {channel.value}
                </span>
              </div>
              <div className="h-2 w-full rounded-full bg-[#F1F5F9]">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: `${(channel.value / total) * 100}%` }}
                  transition={{ delay: 0.7, duration: 0.5 }}
                  className="h-2 rounded-full"
                  style={{ backgroundColor: channel.color }}
                />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}